import { Component, EventEmitter, Input, Output, OnInit, signal, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { ToastService } from 'angular-toastify';
import { AccessRole } from '../../../../../core/models/system-settings/manage-roles.model';
import { ApiSystemSettingsService } from '../../../../../core/services/api/system-settings/api-system-settings.service';
import { MapperManageRolesService } from '../../../../../core/mappers/system-settings/mapper-manage-roles.service';
import { MenuPermissionService } from '../../../../../core/services/menu-permission.service';
import { ModalAdminActivityHistoryComponent } from '../modal-admin-activity-history/modal-admin-activity-history.component';
import { AdminActivityEntityTypes } from '../../../../../core/models/system-settings/admin-activity-log.model';

@Component({
  selector: 'app-modal-manage-role',
  standalone: true,
  imports: [CommonModule, FormsModule, ModalAdminActivityHistoryComponent],
  templateUrl: './modal-manage-role.component.html',
  styleUrl: './modal-manage-role.component.css'
})
export class ModalManageRoleComponent implements OnInit {
  @Input() data: AccessRole | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() saveSuccess = new EventEmitter<void>();

  readonly activityEntityTypes = AdminActivityEntityTypes;
  showActivityHistory = false;

  formData: Partial<AccessRole> = {
    id: 0,
    name: '',
    viewer: false,
    canCreate: false,
    canEdit: false,
    canDelete: false,
    canMenuRole: false,
    approve: false,
    status: true,
  };

  isLoading = signal<boolean>(false);

  private toast = inject(ToastService);
  private apiService = inject(ApiSystemSettingsService);
  private mapper = inject(MapperManageRolesService);
  private cookieService = inject(CookieService);
  private router = inject(Router);
  private permissionService = inject(MenuPermissionService);

  ngOnInit() {
    if (this.data) {
      this.formData = { ...this.data };
    }
  }

  onClose() {
    this.close.emit();
  }

  onSave() {
    if (!this.formData.name?.trim()) {
      this.toast.error('กรุณากรอกชื่อ Role');
      return;
    }

    this.isLoading.set(true);

    const userIdStr = this.cookieService.get('user_id');
    const userId = userIdStr ? parseInt(userIdStr, 10) : 0;
    const currentPath = this.router.url;
    const menuId = this.permissionService.getMenuId(currentPath) || 15;

    const payload = this.mapper.mapAccessRoleToPayload(this.formData as AccessRole, userId, menuId);

    if (this.formData.id) {
      this.apiService.updateRole(payload, this.formData.id).subscribe({
        next: (res: any) => {
          console.log("update data : ", res, JSON.stringify(res));
          if (res?.isSuccess) {
            this.toast.success('แก้ไขข้อมูลสำเร็จ');
            this.saveSuccess.emit();
            this.close.emit();
          } else {
            this.toast.error(res?.message || 'แก้ไขข้อมูลไม่สำเร็จ');
          }
          this.isLoading.set(false);
        },
        error: (err: any) => {
          console.error(err);
          this.toast.error('เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์');
          this.isLoading.set(false);
        }
      });
    } else {
      this.apiService.createRole(payload).subscribe({
        next: (res: any) => {
          console.log("create data : ", res, JSON.stringify(res));
          if (res?.isSuccess) {
            this.toast.success('สร้างข้อมูลสำเร็จ');
            this.saveSuccess.emit();
            this.close.emit();
          } else {
            this.toast.error(res?.message || 'สร้างข้อมูลไม่สำเร็จ');
          }
          this.isLoading.set(false);
        },
        error: (err: any) => {
          console.error(err);
          this.toast.error('เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์');
          this.isLoading.set(false);
        }
      });
    }
  }

  get canShowActivityHistory(): boolean {
    return !!this.formData.id && this.formData.id > 0;
  }

  openActivityHistory(): void {
    if (!this.canShowActivityHistory) return;
    this.showActivityHistory = true;
  }

  closeActivityHistory(): void {
    this.showActivityHistory = false;
  }
}
